// Shared preview library: loads PDF.js once for every app (the copy shipped in public/vendor).
// First used by the Launch Reviews book reader; now shared with Launch Media's PDF previews.
declare global { interface Window { pdfjsLib?: any } }
const PDFJS = "/vendor/pdfjs-3.11.174/";
let ready: Promise<any> | null = null;
export function loadPdfjs(): Promise<any> {
  if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
  if (!ready) ready = new Promise((ok, no) => {
    const s = document.createElement("script"); s.src = PDFJS + "pdf.min.js"; s.async = true;
    s.onload = () => { window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS + "pdf.worker.min.js"; ok(window.pdfjsLib); };
    s.onerror = () => { ready = null; no(new Error("The PDF reader didn't load.")); };
    document.head.appendChild(s);
  });
  return ready;
}
